/**
 * @see [please read this config before use](https://www.tele rik.com/blogs/api-factories-vue-nuxt)
 * @param $axios
 * @param $notify
 * @param redirect
 * @param app
 * @param store
 * @param $logger
 */
import LRU from 'lru-cache'
import { cacheAdapterEnhancer } from 'axios-extensions'
import { checkStatus, gotToMilliSecond, validationBackend } from '@helper/utils.js'
// const ONE_HOUR = 1000 * 60 * 60
export default function ({
  $axios,
  ssrContext,
  $notify,
  app,
  $logger,
  error,
  route,
  redirect
}) {
  const defaultCache = process.server
    ? ssrContext.$axCache
    : new LRU({ ttl: gotToMilliSecond(60), maxSize: 10000, ttlAutopurge: true })

  const defaults = $axios.defaults
  // https://github.com/kuitos/axios-extensions
  defaults.adapter = cacheAdapterEnhancer(defaults.adapter, {
    enabledByDefault: false,
    cacheFlag: 'useCache',
    defaultCache
  })

  $axios.onRequest((config) => {
    try {
      const token = app.$auth.strategy.token.get()
      if (token) {
        config.headers.Authorization = token
      }
      if (process.env.NODE_ENV !== 'production') {
        console.log(config.url)
      }
      return config
    } catch (e) {
      return config
    }
  })
  $axios.onResponse((response) => {
    const { data } = response
    const { showNotify } = response.config
    if (showNotify) {
      const { message = null, status } = data
      if (checkStatus(status)) {
        if (message) {
          $notify.success({
            message
          })
        }
      }
    }
  })
  $axios.onError((err) => {
    if (app.$config.mode === 'development') {
      console.log(err)
    }
    if (!err.response) {
      $logger.captureException({ error: err, type: 'fetch-error' })
      return
    }
    const code = parseInt(err.response && err.response.status)
    const response = err.response
    const { data } = response
    if (!data) {
      $logger.captureException({ error: err, type: 'fetch-error' })
      return
    }
    const { message } = data
    if (code && [500, 503, 401, 400, 302, 301, 422, 429].includes(code)) {
      if ([500, 503, 504].includes(code)) {
        if (err.response.config.errorTypeCheck === 'ignore-500' && code === 500) {
          return err
        }
        if (app.$config.mode === 'development') {
          error({ statusCode: code, config: err.config, message })
        } else {
          error({ statusCode: code })
        }
        return
      }
      if (code === 422) {
        validationBackend(err, (name, value) => {
          app.$notify.error({
            message: value
          })
        })
        return
      }
      if (message) {
        if (code === 301) {
          if (route.name.startsWith(app.$routeName.tutor_profile)) {
            redirect(
              301,
              app.localePath({
                name: app.$routeName.tutor_profile,
                params: {
                  name: data.errors.new_username
                }
              })
            )
          }
        }
        if (code === 302) {
          $notify.info({
            message
          })
          if (err.response.data.errors) {
            const { next_step = null, route_name = null } = err.response.data.errors
            if (route_name && route_name.includes('TUTOR_REQUEST')) {
              redirect(
                app.localePath({
                  name: app.$routeName[route_name.toLowerCase()],
                  query: err.response.data.errors?.queries,
                  params: err.response.data.errors?.params
                })
              )
            }
            if (next_step && app.$routeName[next_step]) {
              if (['view_profile_dashboard', 'view_teacher_requests_list'].includes(next_step)) {
                redirect(
                  app.localePath({
                    name: app.$routeName.dashboard_name
                  })
                )
                return
              }
              if (['teacher_dashboard'].includes(next_step)) {
                window.location = app.$config.base_url_website + app.$routeName[next_step]
                return
              }
              redirect(
                app.localePath({
                  name: app.$routeName[next_step],
                  query: {
                    teacher_request_id: route.query.teacher_request_id
                  }
                })
              )
            }
            const { redirect_url } = err.response.data.errors
            if (redirect_url) {
              redirect(302, redirect_url)
            }
          }
        } else {
          $notify.error({
            message
          })
        }
      }
      if (code === 401) {
        const redirectToLogin = () => {
          if (route.path !== '/auth/login') {
            redirect(`${app.$routeName.login}?redirect_url=${app.$auth.$storage.getLocalStorage('latestRoute')}`)
          }
        }
        if (app.$auth.loggedIn) {
          app.$auth.logout().finally(() => {
            redirectToLogin()
          })
          return
        }
        if (!process.server) {
          redirectToLogin()
        }
      }
    }
    if (code && [400].includes(code)) {
      $logger.captureException({ error: err, type: 'fetch-error' })
      if (err.response.config.errorTypeCheck === 'ignore-400') {
        return err
      }
    }
    if (code === 404) {
      if (app.$config.mode !== 'development') {
        error({
          statusCode: code,
          message: message || 'not found end point or method'
        })
      }
    }
    if (code === 410) {
      error({
        statusCode: 410,
        message: message || 'اطلاعات مورد نظر یافت نشد'
      })
    }
  })
}
